const PropertyConditions = [
  { id: "-1", name: "Please select building condition" },
  { id: "1", name: "Poor" },
  { id: "2", name: "Average" },
  { id: "3", name: "New" },
];

export default PropertyConditions;
